import { gql } from '@apollo/client';

export const GET_EXAMS_BY_USER_CONNECTION = gql`
  query GetExamsByUserConnection(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $nameSearch: String
    $technology: EnumExamTechnology
    $afterDate: Date
    $beforeDate: Date
  ) {
    examsByUserConnection(
      after: $after
      before: $before
      first: $first
      last: $last
      nameSearch: $nameSearch
      technology: $technology
      afterDate: $afterDate
      beforeDate: $beforeDate
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          _id
          user {
            fullName
          }
          patient {
            _id
            firstName
            lastName
            fullName
            identificationNumber
            identificationType
          }
          examDate
          priority
          relevantFindingsCount
          status
          detectionsCount
          histologicalResult
        }
      }
    }
  }
`;
